import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/'

export default {
	async [actionTypes.ATA.ACOMPANHAMENTO.BUSCAR_POR_FILTRO](context, { filtros, paginacao, idAta }) {
		const { data } = await api.acompanhamentoAta.buscarPorFiltro(filtros, paginacao, idAta)
		return data
	},
	async [actionTypes.ATA.ACOMPANHAMENTO.BUSCAR_LISTAGEM_SALDO_ORGAO_POR_ITEM](
		context,
		{ paginacao, idAta, idItemAta },
	) {
		const { data } = await api.acompanhamentoAta.buscarListagemDeOrgaosPorItem(paginacao, idAta, idItemAta)
		return data
	},
	async [actionTypes.ATA.ACOMPANHAMENTO.BUSCAR_LISTAGEM_DETALHES_SALDO_POR_ORGAO](
		context,
		{ filtros, paginacao, idAta, idItem },
	) {
		const { data } = await api.acompanhamentoAta.buscarListagemDetalhesSaldoPorOrgao(
			filtros,
			paginacao,
			idAta,
			idItem,
		)
		return data
	},
}
